// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M1.5 3.5H14.5M3.5 8H12.5M2.88 12.5H13.13'];
